module.exports = __webpack_public_path__ + "static/img/indexbg2.e192895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg2.png
// module id = 8POz
// module chunks = 1